import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { PurchaseOrderSellerSummary } from "../types";
import { queryKeys } from "./queryKeys";

const fetchSupplierOcs = async (): Promise<PurchaseOrderSellerSummary[]> => {
  const { data } = await axios.get("/purchase-orders/supplier");
  return data;
};

/**
 * The OCs addressed to the caller's company (seller portal). The backend only returns SENT-or-beyond
 * OCs, scoped to the caller's company; it is gated by SELLER_RESPOND_PURCHASE_ORDERS, not a module flag.
 */
export const useSupplierOcs = () =>
  useQuery<PurchaseOrderSellerSummary[], Error>({
    queryKey: [queryKeys.SUPPLIER_PURCHASE_ORDERS],
    queryFn: fetchSupplierOcs,
  });
